import { render, staticRenderFns } from "./Sampled.vue?vue&type=template&id=a210d04a&scoped=true"
import script from "./Sampled.vue?vue&type=script&lang=js"
export * from "./Sampled.vue?vue&type=script&lang=js"
import style0 from "./Sampled.vue?vue&type=style&index=0&id=a210d04a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a210d04a",
  null
  
)

export default component.exports